import { createStore } from 'vuex';

export default createStore({
  state: {
    loading: true,
    config: null,
    locations: null,
  },
  getters: {
    config: state => state.config,
    loading: state => state.loading,
    locations: state => state.locations,
    options: state => state.config.mapOptions,
  },
  mutations: {
    setStateValue(state, payload) {
      state[payload.key] = payload.value;
    },
  },
  actions: {
    async loadConfig({ commit }, payload) {
      await fetch(payload)
        .then(res => res.json())
        .then(data => {
          commit('setStateValue', { key: 'config', value: data });
        })
        .catch(err => {
          console.error(err);
        });
    },
    async loadLocations({ commit }, payload) {
      let ready = false;
      let minTime = setInterval(() => {
        if (ready) {
          clearInterval(minTime);
          commit('setStateValue', { key: 'loading', value: false });
        }
      }, 500);
      return await fetch(payload)
        .then(res => res.json())
        .then(data => {
          data.Locations.forEach(loc => {
            loc['viewLobbyHours'] = false;
            loc['viewDriveThruHours'] = false;
          });
          commit('setStateValue', { key: 'locations', value: data.Locations });
          ready = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  modules: {},
});
